import React, { useMemo } from 'react'
import { useHits } from 'react-instantsearch-hooks-web'
import { FirmAlgoliaSearchResult, FirmTeaserMapper } from '../firm'
import { FirmCta, FirmTeaser, FirmTeaserProps } from '../../firms'
import { AlgoliaPagination as PaginationComponent } from '../AlgoliaPagination'

export const FirmSearchLists = () => {
  const { results } = useHits<FirmAlgoliaSearchResult>()

  if (!results) {
    return null
  }

  const lists = useMemo(() => {
    const mappedFirms = results.hits.map((hit) => FirmTeaserMapper({ hit }))
    const otherFirms = mappedFirms.filter((hit) => !hit.subscriptionType)
    const firms = mappedFirms.filter((hit) => Boolean(hit.subscriptionType))

    return { otherFirms, firms, mappedFirms }
  }, [results.hits])

  return (
    <section className="space-y-18">
      <FirmList firms={lists.firms} />

      {lists.firms.length > 4 && (
        <FirmCta
          type="offer"
          title="Vous méritez que les cabinets vous contactent directement ?"
        />
      )}

      <FirmList
        firms={lists.otherFirms}
        title="D'autres cabinets non référencés peuvent aussi vous intéresser"
      />

      {lists.mappedFirms.length === 0 && (
        <div>
          <h2 className="mb-6 text-2xl font-bold text-night">
            Aucun cabinet trouvé
          </h2>
        </div>
      )}

      {lists.otherFirms.length > 4 && (
        <FirmCta
          type="offer"
          title="Vous méritez que les cabinets vous contactent directement ?"
        />
      )}

      <PaginationComponent ariaLabel="Pagination des résultats de recherche des cabinets" />
    </section>
  )
}

const FirmList = ({
  firms = [],
  title,
}: {
  firms: FirmTeaserProps[]
  title?: string
}) => {
  if (firms?.length === 0) {
    return null
  }

  return (
    <div>
      {title && <h2 className="mb-6 text-2xl font-bold text-night">{title}</h2>}
      <ul className="grid grid-flow-row grid-cols-1 gap-9 text-neutral-600 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {firms.map((hit) => (
          <li key={hit.url}>
            <FirmTeaser {...hit} />
          </li>
        ))}
      </ul>
    </div>
  )
}
